import { render, staticRenderFns } from "./BranchInfo.vue?vue&type=template&id=24b04dda&scoped=true"
import script from "./BranchInfo.vue?vue&type=script&lang=js"
export * from "./BranchInfo.vue?vue&type=script&lang=js"
import style0 from "./BranchInfo.vue?vue&type=style&index=0&id=24b04dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b04dda",
  null
  
)

export default component.exports